<ul class="pagination">
  <li class="pagination__item" *ngIf="pages?.current !== 1">
    <vc-ref class="pagination__link" resource="/{{ currentPath }}/" [anchor]="anchorPagination">1</vc-ref>
  </li>
  <li *ngIf="currentStart > rangeStart" class="pagination__item">
    <span>...</span>
  </li>
  <ng-container *ngIf="nbOfPages > 1">
    <li
      *ngFor="let page of range"
      class="pagination__item"
      [ngClass]="{'pagination__item--current': pages?.current === page}"
    >
      <ng-container *ngIf="pages?.current !== page; else currentLink">
        <vc-ref class="pagination__link" resource="/{{ currentPath }}/p-{{ page }}/" [anchor]="anchorPagination">
          {{ page }}
        </vc-ref>
      </ng-container>
      <ng-template #currentLink>
        <span class="pagination__link">{{ page }}</span>
      </ng-template>
    </li>
  </ng-container>
</ul>
